module.exports = __webpack_public_path__ + "img/dental8_7-8-2021.d65d5ebc.jpg";